module.exports = __webpack_public_path__ + "images/notifications-onboarding/unread_Illos.68a4f5e0217a7a97637e.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/notifications-onboarding/unread_Illos.svg
// module id = 11p/
// module chunks = 24